import { render, staticRenderFns } from "./mdf-add-activity-type-widget.vue?vue&type=template&id=12237f8a&"
import script from "./mdf-add-activity-type-widget.vue?vue&type=script&lang=js&"
export * from "./mdf-add-activity-type-widget.vue?vue&type=script&lang=js&"
import style0 from "./mdf-add-activity-type-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports